(function() {
  'use strict';

  angular.module('app.technical', []);
})();
